
	import {defineComponent, computed} from "@vue/runtime-core";
	import {useStore} from "@/store";
	import ChatMessage from "@/components/chat/ChatMessage.vue";

	export default defineComponent({
		components: {
			ChatMessage
		},
		setup() {
			const store = useStore(),
				messages = computed(() => store.state.chat.messages);

			return {
				messages,
			}
		}
	})
